import statistic from '@/store/modules/statistic.js'
import { authRequest } from './index.js'

export async function retrieve_children(params){
  let data
  await authRequest.get(
    '/childrens',
    {
      params: params
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function retrieve_child(id, params = '?reports=true&meta=true'){
  let data
  await authRequest.get(
    '/children/' + id + params
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_stats(report_id, trait_ids){
  let data
  let updateTraitIds = trait_ids.map((trait)=>{
    return {
      id: trait.report_metum_id,
      trait_id: trait.id,
      score: trait.value,
      _destroy: trait._destroy
    }
  })
  await authRequest.post(
    '/report/' + report_id,
    {report: {
      report_meta_attributes: updateTraitIds
    }},
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_status(child_id, status){
  let data
  // console.log("🚀 ~ file: child.js:42 ~ updateTraitIds ~ updateTraitIds:", updateTraitIds)
  await authRequest.patch(
    '/children/' + child_id,
    {children: {
      status
    }},
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function delete_child(child_id){
  let data
  await authRequest.delete(
    '/children/' + child_id,
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function filterChildren(filterObj){
  let data
  await authRequest.get(
    '/childrens',
    {
      params: filterObj
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function age_distribution(filterObj){
  let data
  await authRequest.get(
    '/children/age_distribution',
    {
      params: filterObj
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function updateLevelUp(notification_id){
  let data
  await authRequest.get(
    '/notifications/' + notification_id + '/level_up'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function add_child_meta(child_id, child_meta){
  let data
  await authRequest.post(
    '/children/'+ child_id +'/meta',
    {child_meta},
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function retrieve_child_meta(child_id, params){
  let data
  await authRequest.get(
    '/children/' + child_id + '/meta' + '?' +params
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}